import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]
  static values = { originalUrl: String }

  openFullscreen(event) {
    // Solo abrir pantalla completa si no se hizo clic en el menú
    if (event.target.closest('.media-menu')) {
      return
    }

    const mediaElement = this.element.querySelector('img, video')
    if (!mediaElement) return

    // Crear modal de pantalla completa
    this.createFullscreenModal(mediaElement)
  }

  toggleMenu(event) {
    event.stopPropagation()

    // Cerrar otros menús abiertos
    document.querySelectorAll('.media-menu-dropdown').forEach(menu => {
      if (menu !== this.menuTarget) {
        menu.style.display = 'none'
      }
    })

    // Toggle del menú actual
    const isVisible = this.menuTarget.style.display !== 'none'
    this.menuTarget.style.display = isVisible ? 'none' : 'block'
  }

  createFullscreenModal(mediaElement) {
    // Crear overlay de pantalla completa
    const overlay = document.createElement('div')
    overlay.className = 'fullscreen-overlay'

    // For images, get the original URL instead of thumbnail
    let mediaHTML = mediaElement.outerHTML
    if (mediaElement.tagName === 'IMG' && this.hasOriginalUrlValue) {
      // Replace the src in the HTML
      mediaHTML = mediaHTML.replace(/src="[^"]*"/, `src="${this.originalUrlValue}"`)
    }

    overlay.innerHTML = `
      <div class="fullscreen-content">
        <button class="fullscreen-close" aria-label="Cerrar pantalla completa">
          <i class="fas fa-times"></i>
        </button>
        <div class="fullscreen-media">
          ${mediaHTML}
        </div>
      </div>
    `

    // Agregar estilos
    const style = document.createElement('style')
    style.textContent = `
      .fullscreen-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.9);
        z-index: 9999;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }

      .fullscreen-content {
        position: relative;
        max-width: 95vw;
        max-height: 95vh;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .fullscreen-close {
        position: absolute;
        top: -40px;
        right: 0;
        background: rgba(255, 255, 255, 0.2);
        border: none;
        color: white;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        z-index: 10000;
      }

      .fullscreen-close:hover {
        background: rgba(255, 255, 255, 0.3);
      }

      .fullscreen-media img {
        max-width: 90vw;
        max-height: 90vh;
        width: auto;
        height: auto;
        object-fit: contain;
        border-radius: 8px;
        min-width: 40vw;
        min-height: 40vh;
      }

      .fullscreen-media video {
        max-width: 100%;
        max-height: 100%;
        width: auto;
        height: auto;
        object-fit: contain;
        border-radius: 8px;
      }
    `

    document.head.appendChild(style)
    document.body.appendChild(overlay)

    // Configurar video para pantalla completa
    const fullscreenVideo = overlay.querySelector('video')
    if (fullscreenVideo) {
      fullscreenVideo.controls = true
      fullscreenVideo.autoplay = true
      fullscreenVideo.style.maxWidth = 'none'
      fullscreenVideo.style.maxHeight = 'none'
    }

    // Event listeners para cerrar
    const closeModal = () => {
      document.body.removeChild(overlay)
      document.head.removeChild(style)
    }

    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) {
        closeModal()
      }
    })

    overlay.querySelector('.fullscreen-close').addEventListener('click', closeModal)

    // Cerrar con Escape
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        closeModal()
        document.removeEventListener('keydown', handleEscape)
      }
    }
    document.addEventListener('keydown', handleEscape)
  }

}
